import React, { useEffect, useState } from 'react';
import logo from "./logo_g1.png"
import { Container, Nav, NavDropdown, Button } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import "./navbar.css";

function Navbar() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setIsAuthenticated(true);
                setIsAdmin(decoded?.is_admin === true);
            } catch (err) {
                console.error("Ungültiges Token", err);
                localStorage.removeItem("token");
            }
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        setIsAdmin(false);
        window.location.href = "/"; // optional reload or redirect
    };

    return (
        <div className='card'>
            <div className='topic' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h1 style={{ margin: 0 }}>TSC Stahl Hennigsdorf e.V.</h1>
                <img src={logo} alt="" className='logo' style={{ marginLeft: 'auto' }} />
            </div>
            <Container fluid>
                <Nav className="me-auto">
                    <Nav.Link href="/">Home</Nav.Link>
                    <NavDropdown title="Der Verein" id="basic-nav-dropdown">
                        <NavDropdown.Item href="/verein">Der Verein</NavDropdown.Item>
                        <NavDropdown.Item href="/kalender">Kalender</NavDropdown.Item>
                        <NavDropdown.Item href="/verbaende">Verbände</NavDropdown.Item>
                        <NavDropdown.Item href="/mitglied-werden">Mitglied werden</NavDropdown.Item>
                        <NavDropdown.Item href="/satzung-ordnung">Satzung und Ordnungen</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Tauchausbildung" id="basic-nav-dropdown">
                        <NavDropdown.Item href="/ausbildung">Ausbildung</NavDropdown.Item>
                        <NavDropdown.Item href="/schwimmhallentraining">Schwimmhallentraining</NavDropdown.Item>
                        <NavDropdown.Item href="/medizin">Tauchmedizin & Gesundheit</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Kinder und Jugend" id="basic-nav-dropdown">
                        <NavDropdown.Item href="/kinder-jugend/training">Kinder- und Jugendtraining</NavDropdown.Item>
                        <NavDropdown.Item href="/umwelt">Umwelt</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="/galerie">Galerie</Nav.Link>
                    <NavDropdown title="Kontakt und Impressum" id="basic-nav-dropdown">
                        <NavDropdown.Item href="/kontakt">Kontakt</NavDropdown.Item>
                        <NavDropdown.Item href="/impressum">Impressum</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="/tsc-blog">TSC Blog</Nav.Link>
                    {isAuthenticated && <Nav.Link href="/mitglieder">Mitglieder</Nav.Link>}
                    {isAdmin && <Nav.Link href="/admin/home">Admin</Nav.Link>}
                    {isAuthenticated ? (
                        <Button variant="link" onClick={handleLogout} className="nav-link">Logout</Button>
                    ) : (
                        <Nav.Link href="/login">Login</Nav.Link>
                    )}
                </Nav>
            </Container>
        </div>
    );
}

export default Navbar;
